export enum MimeType {
  VIDEO = '.mp4,.m4v,.webm,.mov,.wmv,.avi',
  IMAGE = '.jpg,.png,.jpeg,.webp,.avif',
  AUDIO = '.mp3',
  FONT = '.otf,.ttf',
}

export default MimeType;
